/**
 * InvestmentStrategy Component
 * Explains the firm's investment approach and pillars
 */

import { STRATEGY_PILLARS } from '../utils/constants';
import { createFinancialGraph } from './FinancialGraph';

export function createInvestmentStrategy(): string {
  const growthImage = '/Users/lloyd.vince1985gmail.com/.gemini/antigravity/brain/2cc06dd9-bcbd-449f-bd28-ac1d18b43ffe/professional_business_growth_1772988590441.png';

  return `
    <!-- ════════════════════════════════════
         INVESTMENT STRATEGY
    ════════════════════════════════════ -->
    <section id="strategy" style="background:#000000; position:relative; overflow:hidden;">

      <!-- Decorative Backdrop Image -->
      <div style="position:absolute; left:-10%; top:20%; width:40%; height:60%; z-index:0; opacity:0.04; filter:grayscale(1);">
        <img src="${growthImage}" alt="" style="width:100%; height:100%; object-fit:cover; border-radius:50%;">
      </div>

      <div style="max-width:1320px; margin:0 auto; padding:0 48px; position:relative; z-index:1;">

        <div class="strategy-intro-grid" style="display:grid; grid-template-columns: 1fr 1fr; gap:80px; align-items: flex-start; margin-bottom:80px;">
          <div>
            <div class="reveal" style="display:flex; align-items:center; gap:18px; margin-bottom:32px;">
              <span class="eyebrow">Strategy</span>
              <span class="gold-rule"></span>
            </div>
            <h2 class="reveal d1" style="
              font-family:'Cormorant Garamond',serif;
              font-size:clamp(44px, 4.8vw, 64px);
              font-weight:500;
              line-height:1.15;
              color:#F8F7F4;
              max-width:540px;">
              A Disciplined Approach to <span style="color:#C9A227;">Long-term</span> Value Creation
            </h2>
            <p class="reveal d2" style="
              font-family:'Inter',sans-serif;
              font-size:18px;
              line-height:1.75;
              color:rgba(248,247,244,0.55);
              max-width:500px;
              margin-top:36px;">
              Arceus is guided by a conviction that exceptional individuals, paired with the right capital and strategic expertise, can generate compounding long-term value over a patient investment horizon.
            </p>
          </div>

          <div class="reveal d3" style="padding-top:40px;">
            ${createFinancialGraph()}
          </div>
        </div>

        <!-- Strategy Pillars Grid -->
        <div class="strategy-pillars-grid" style="display:grid; grid-template-columns: repeat(3, 1fr); gap:48px;">
          ${STRATEGY_PILLARS.map((pillar, index) => `
            <div class="reveal strategy-pillar-card d${index + 1} glass" style="padding:48px 40px; border-radius:12px; transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1); border: 1px solid rgba(201, 162, 39, 0.1); background: rgba(255,255,255,0.02);"
              onmouseover="this.style.borderColor='rgba(201, 162, 39, 0.4)'; this.style.transform='translateY(-8px)'; this.style.boxShadow='0 20px 40px rgba(0,0,0,0.4)';"
              onmouseout="this.style.borderColor='rgba(201, 162, 39, 0.1)'; this.style.transform='translateY(0)'; this.style.boxShadow='none';">
              <div style="color:#C9A227; margin-bottom:24px;">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <h3 style="
                font-family:'Cormorant Garamond',serif;
                font-size:32px;
                font-weight:600;
                color:#F8F7F4;
                margin-bottom:18px;">
                ${pillar.title}
              </h3>
              <p style="
                font-family:'Inter',sans-serif;
                font-size:16px;
                line-height:1.7;
                color:rgba(248,247,244,0.45);">
                ${pillar.description}
              </p>
            </div>
          `).join('')}
        </div>

      </div>
    </section>
  `;
}

export default createInvestmentStrategy;
